import * as yup from "yup"

export const validationSchema = yup.object().shape({
    mr_group_task_code: yup.string().label("Group task code").required().min(2).max(3),
    mr_group_task_name: yup.string().label("Group task name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional()
})